import React from 'react';
import { IconButton } from '@material-ui/core';
import { Description as DescriptionIcon } from '@material-ui/icons';
import { getYearMonthDate } from '../calendar';
import styles from './DayView.module.css';

const DayView = ({ day, settlement, onClickMemo }) => {

  if (!settlement) {
    return (
      <div className={styles.dayView}></div>
    );
  }

  const adjustments = [];
  if (settlement.fee && parseInt(settlement.fee) != 0) {
    adjustments.push(settlement.fee);
  }
  if (settlement.adjust && parseInt(settlement.adjust) != 0) {
    adjustments.push(settlement.adjust);
  }

  return (
    <div className={styles.dayView}>
      {/* menu */}
      <div className={styles.orderInfo}>
      {settlement.menu.filter(m => m.orderQty > 0).map((m, i) => (
        <div
          key={i}
          className={styles.order}
        >
          <div className={styles.menu}>{m.name}</div>
          <div className={styles.orderQty}>{m.orderQty}</div>
        </div>
      ))}
        <div className={styles.totalCount}>
          {`총 ${settlement.totalCount}건`}
        </div>
      </div>
      {/* amount */}
      <div className={styles.amountInfo}>
        <div className={styles.sellAmount}>
          &#65510;{settlement.sellAmount}
        </div>
        <div className={styles.adjustments}>
          {adjustments.map((el, i) => {
            // adjust 값은 반대로 표시 
            const isPositive = el.startsWith('-');
            const presentValue = isPositive ? el.substring(1) : el;
            return (
              <div
                key={i}
                className={isPositive ? styles.positive : styles.negative}
              >
                {`${isPositive ? '+' : '-' } \uFFE6${presentValue}`}
              </div>
            )
          })}
        </div>
        <div className={styles.totalAmount}>
          &#65510;{settlement.calculated}
        </div>
      </div>
      {/* memo */}
      <div className={styles.memo}>
        <IconButton
          size="small"
          aria-label="memo"
          onClick={onClickMemo}
          data-date={getYearMonthDate(day)}
        >
          <DescriptionIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  );
}

export default DayView;